import { render, staticRenderFns } from "./OrderInfoCard.vue?vue&type=template&id=5b4c32fb&scoped=true&"
import script from "./OrderInfoCard.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInfoCard.vue?vue&type=style&index=0&id=5b4c32fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c32fb",
  null
  
)

export default component.exports